<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn small depressed color="secondary" v-on="on">{{$t('newUser')}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("user")}}</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  outlined
                  dense
                  required
                  :rules="nameRules()"
                  v-model="firstname"
                  v-bind:label="$t('firstname')"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  required
                  :rules="nameRules()"
                  v-model="name"
                  v-bind:label="$t('name')"
                ></v-text-field>

                <v-select
                  :rules="profileRules()"
                  :items="profiles"
                  item-value="LicenseXProfileId"
                  outlined
                  dense
                  item-text="Name"
                  v-model="profile"
                  :label="$t('profile')"
                ></v-select>
                <v-text-field
                  outlined
                  dense
                  required
                  :rules="emailRules()"
                  browser-autocomplete="new-password"
                  autocomplete="new-password"
                  v-model="email"
                  v-bind:label="$t('contactEmail')"
                  persistent-hint
                  :hint="$t('contactEmailHint')"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  required
                  :rules="emailRules()"
                  browser-autocomplete="new-password"
                  autocomplete="new-password"
                  v-model="login"
                  v-bind:label="$t('loginEmail')"
                  persistent-hint
                  :hint="$t('loginEmailHint')"
                ></v-text-field>

                <v-text-field
                  outlined
                  dense
                  browser-autocomplete="new-password"
                  autocomplete="new-password"
                  :type="show ? 'text' : 'password'"
                  v-model="inputP"
                  :rules="passwordRules()"
                  v-bind:label="$t('password')"
                  :append-icon="show ? 'visibility' : 'visibility_off'"
                  @click:append="show = !show"
                  required
                  @input="encrypt"
                ></v-text-field>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
import sha256 from "sha256";
import jwtdecode from "jwt-decode";

export default {
  name: "addInstaller",
  props: ["profiles"],
  data: () => ({
    show: false,
    dialog: false,
    email: "",
    login: "",
    inputP: "",
    name: "",
    firstname: "",
    key: "",
    profile: null,
    valid: true
  }),
  methods: {
    close() {
      this.dialog = false;
    },
    nameRules() {
      return [v => !!v || `${this.$t("name")} ${this.$t("required")}`];
    },
    profileRules() {
      return [v => !!v || ""];
    },
    emailRules() {
      return [
        v => !!v || `${this.$t("email")} ${this.$t("required")}`,
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || `${this.$t("email")} ${this.$t("invalid")}`;
        }
      ];
    },
    passwordRules() {
      return [
        v => !!v || `${this.$t("password")} ${this.$t("required")}`,
        v => v.length >= 8 || `${this.$t("min8")}`
      ];
    },
    encrypt() {
      this.key = sha256(this.inputP);
    },

    save() {
      if (this.$refs.form.validate()) {
        const newInstaller = {
          email: this.email,
          firstname: this.firstname,
          name: this.name,
          key: this.key,
          email: this.email,
          login: this.login,
          customerId: jwtdecode(localStorage.getItem("auth")).customerId,
          LicenseXProfileId: this.profile,
          iHubApplicationId: 2
        };
        this.$emit("add-installer", newInstaller);
        this.close();
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Users/AddUser.vue